import React, { useEffect, useState } from 'react'
import { Row, Col, Divider, Spin, } from 'antd'
import NormalDissatisfied from 'components/icons/NormalDissatisfied'
import Dissatisfied from 'components/icons/Dissatisfied'
import Satisfied from 'components/icons/Satisfied'
import { getSingleEligibleRoleDetails } from './actions.js'
import { useDispatch } from 'react-redux'
import { formatAMPM } from '../../../modules/JobPreview/constant'
import { dateConversion } from '../../../utils/rolecreationHelpers'
import { 
  EligibilityContainer,
  EligibilitySection,
  SectionTitle,
  CriteriaContainer,
  CriteriaContent,
  CriteriaLabel,
  CriteriaValue,
  IconWrapper,
  Avatar
} from './style'


const EligibilityCriteria = ({data,previewData,status}) => {
  // Function to render the appropriate icon based on status
  const [firstTimeLoading, setFirstTimeLoading] = useState(false)
  const [eligibilityCriteria, setEligibilityCriteria] = useState([])
  const dispatch = useDispatch()
  
  // Format an experience number (e.g., 1.3) to "1 Year 3 Months"
  const formatExperienceValue = (val) => {
    if (val === null || val === undefined || val === '') return ''
    const num = Number(val)
    if (Number.isNaN(num)) return ''
    const years = Math.floor(num)
    // Decimal represents months in tenths (e.g., .3 => 3 months)
    let months = Math.round((num - years) * 10)
    // Guard against any unexpected values
    if (months < 0) months = 0
    if (months > 9) months = 9
    const yearPart = years > 0 ? `${years} ${years === 1 ? 'Year' : 'Years'}` : ''
    const monthPart = months > 0 ? `${months} ${months === 1 ? 'Month' : 'Months'}` : ''
    if (yearPart && monthPart) return `${yearPart} ${monthPart}`
    if (yearPart) return yearPart
    if (monthPart) return monthPart
    return '0 Months'
  }

  // Format an experience range array like [1.3, 2.3]
  const formatExperienceRange = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return ''
    const [start, end] = arr
    const s = formatExperienceValue(start)
    const e = formatExperienceValue(end)
    if (s && e) return `${s} - ${e}`
    return s || e || ''
  }
  useEffect(() => {
    if(data?.id){
    fetchEligleDetails()
    }
  }, [data?.id])
  const fetchEligleDetails = async () => {
    setFirstTimeLoading(true)
    if(!data?.id){
      return
    }
    let response = await dispatch(getSingleEligibleRoleDetails(data?.id,previewData?.id))
    setEligibilityCriteria(response)
    setFirstTimeLoading(false)
    return response
  }
  const renderStatusIcon = (statusCheck) => {
    // Always show fail icon for MISSED status
    if (status === 'MISSED') {
      return <NormalDissatisfied style={{ flexShrink: 0 }} />;
    }
    
    if (statusCheck === 'pass') {
      return <Satisfied style={{ flexShrink: 0 }} />;
    } else {
      return <Dissatisfied style={{ flexShrink: 0 }} />;
    }
  };

  return (
    <EligibilityContainer status={status}>
      {firstTimeLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
          <Spin size="small" />
        </div>
      ) : (
        <>
          <SectionTitle>Eligibility Criteria</SectionTitle>
      
      <Row>
        <Col span={12}>
          <EligibilitySection>
            <CriteriaContainer>
              <IconWrapper>
                {renderStatusIcon(eligibilityCriteria?.isDegreeEligible ? 'pass' : 'fail')}
              </IconWrapper>
              <CriteriaContent>
                <CriteriaLabel>Degree & Department</CriteriaLabel>
                <CriteriaValue>
                  {previewData?.currentCourse ? (
                    <>
                      {previewData?.currentCourse?.domain && (
                        <>Domain : {previewData?.currentCourse?.domain}{(previewData?.currentCourse?.degree || previewData?.currentCourse?.department) ? ' > ' : ''}</>
                      )}
                      {previewData?.currentCourse?.degree && (
                        <>Degree : {previewData?.currentCourse?.degree}{previewData?.currentCourse?.department ? ' > ' : ''}</>
                      )}
                      {previewData?.currentCourse?.department && (
                        <>Department : {previewData?.currentCourse?.department}</>
                      )}
                      {previewData?.currentCourse?.specialization && (
                        <>{(previewData?.currentCourse?.domain || previewData?.currentCourse?.degree || previewData?.currentCourse?.department) ? ' > ' : ''}Specialization : {previewData?.currentCourse?.specialization}</>
                      )}
                    </>
                  ) : (
                    eligibilityCriteria?.isDegreeEligible ? 'Eligible' : 'Not Eligible'
                  )}
                </CriteriaValue>
              </CriteriaContent>
            </CriteriaContainer>
          </EligibilitySection>

          <EligibilitySection>
            <CriteriaContainer>
              <IconWrapper>
                {renderStatusIcon(eligibilityCriteria?.isYearOfPassingEligible ? 'pass' : 'fail')}
              </IconWrapper>
              <CriteriaContent>
                <CriteriaLabel>Year of Passing</CriteriaLabel>
                <CriteriaValue>
                  {eligibilityCriteria?.yearOfpassing?.role?.join(', ')}
                </CriteriaValue>
              </CriteriaContent>
            </CriteriaContainer>
          </EligibilitySection>

          {((
  eligibilityCriteria?.score?.role?.tenthScore &&
  eligibilityCriteria?.score?.role?.tenthScore !== '0'
) ||
(
  eligibilityCriteria?.score?.role?.twelfthScore &&
  eligibilityCriteria?.score?.role?.twelfthScore !== '0'
) ||
(
  eligibilityCriteria?.score?.role?.UGScore &&
  eligibilityCriteria?.score?.role?.UGScore !== '0'
) ||
(
  eligibilityCriteria?.score?.role?.PGScore &&
  eligibilityCriteria?.score?.role?.PGScore !== '0'
) ||
(
  eligibilityCriteria?.score?.role?.UGDiplomaScore &&
  eligibilityCriteria?.score?.role?.UGDiplomaScore !== '0'
) ||
(
  eligibilityCriteria?.score?.role?.PGDiplomaScore &&
  eligibilityCriteria?.score?.role?.PGDiplomaScore !== '0'
)
                   ) && (
            <EligibilitySection>
              <CriteriaContainer>
                <IconWrapper>
                  {renderStatusIcon(eligibilityCriteria?.isScoreEligible ? 'pass' : 'fail')}
                </IconWrapper>
                <CriteriaContent>
                  <CriteriaLabel>Scores</CriteriaLabel>
                  <CriteriaValue>
                    {eligibilityCriteria?.score?.role?.tenthScore && eligibilityCriteria?.score?.role?.tenthScore !== '0' && (
                      <>10th - Above {eligibilityCriteria?.score?.role?.tenthScore}%<br /></>
                    )}
                    {eligibilityCriteria?.score?.role?.twelfthScore && eligibilityCriteria?.score?.role?.twelfthScore !== '0' && (
                      <>12th or Equivalent - Above {eligibilityCriteria?.score?.role?.twelfthScore}%<br /></>
                    )}
                    {eligibilityCriteria?.score?.role?.UGScore && eligibilityCriteria?.score?.role?.UGScore !== '0' && (
                      <>UG - Above {eligibilityCriteria?.score?.role?.UGScore}%<br /></>
                    )}
                    {eligibilityCriteria?.score?.role?.PGScore && eligibilityCriteria?.score?.role?.PGScore !== '0' && (
                      <>PG - Above {eligibilityCriteria?.score?.role?.PGScore}%<br /></>
                    )}
                    {eligibilityCriteria?.score?.role?.UGDiplomaScore && eligibilityCriteria?.score?.role?.UGDiplomaScore !== '0' && (
                      <>UG Diploma - Above {eligibilityCriteria?.score?.role?.UGDiplomaScore}%<br /></>
                    )}
                    {eligibilityCriteria?.score?.role?.PGDiplomaScore && eligibilityCriteria?.score?.role?.PGDiplomaScore !== '0' && (
                      <>PG Diploma - Above {eligibilityCriteria?.score?.role?.PGDiplomaScore}%</>
                    )}
                  </CriteriaValue>
                </CriteriaContent>
              </CriteriaContainer>
            </EligibilitySection>
          )}

          <EligibilitySection>
            <CriteriaContainer>
              <IconWrapper>
                {renderStatusIcon(eligibilityCriteria?.isArrearEligible ? 'pass' : 'fail')}
              </IconWrapper>
              <CriteriaContent>
                <CriteriaLabel>Arrears/Backlogs</CriteriaLabel>
                <CriteriaValue>
                  {eligibilityCriteria?.arrear?.roleArrear > 0 ? (
                    <>Up to {eligibilityCriteria?.arrear?.roleArrear} Arrears Allowed</>
                  ) : eligibilityCriteria?.arrear?.roleHistoryArrear > 0 ? (
                    <>Up to {eligibilityCriteria?.arrear?.roleHistoryArrear} History Arrears Allowed</>
                  ) : (
                    <>No Arrears Allowed</>
                  )}
                </CriteriaValue>
              </CriteriaContent>
            </CriteriaContainer>
          </EligibilitySection>
        </Col>
        
        <Col style={{ display: 'flex', justifyContent: 'center' }} span={1}>
          <Divider type="vertical" style={{ height: '100%' }} />
        </Col>
        
        <Col span={11}>
          <Row align="top" justify="space-between">
            <Col>
              {eligibilityCriteria?.skill?.role?.some(skill => skill?.isMandatory) && (
                <EligibilitySection>
                  <CriteriaContainer>
                    <IconWrapper>
                      {renderStatusIcon(eligibilityCriteria?.isSkillEligible ? 'pass' : 'fail')}
                    </IconWrapper>
                    <CriteriaContent>
                      <CriteriaLabel>Skills</CriteriaLabel>
                      <CriteriaValue>
                        {eligibilityCriteria?.skill?.role?.filter(skill => skill?.isMandatory)?.map(skill => skill?.name)?.join(' | ')}
                      </CriteriaValue>
                    </CriteriaContent>
                  </CriteriaContainer>
                </EligibilitySection>
              )}

              <EligibilitySection>
                <CriteriaContainer>
                  <IconWrapper>
                    {renderStatusIcon(eligibilityCriteria?.isLocationEligible ? 'pass' : 'fail')}
                  </IconWrapper>
                  <CriteriaContent>
                    <CriteriaLabel>Location</CriteriaLabel>
                    <CriteriaValue>
                      {eligibilityCriteria?.location?.roleIsAnyWhere ? (
                        'Anywhere'
                      ) : eligibilityCriteria?.location?.role?.length > 0 ? (
                        eligibilityCriteria?.location?.role.map(item => item.name || item.state_name).join(', ')
                      ) : (
                        'No location specified'
                      )}
                    </CriteriaValue>
                  </CriteriaContent>
                </CriteriaContainer>
              </EligibilitySection>
              {eligibilityCriteria?.experience?.role?.length > 1 && 
 !eligibilityCriteria?.experience?.role?.every(item => item === 0) && (
              <EligibilitySection>
                <CriteriaContainer>
                  <IconWrapper>
                    {renderStatusIcon(eligibilityCriteria?.isExperienceEligible ? 'pass' : 'fail')}
                  </IconWrapper>
                  <CriteriaContent>
                    <CriteriaLabel>Work Experience</CriteriaLabel>
                    <CriteriaValue>
                     {formatExperienceRange(eligibilityCriteria?.experience?.role)}
                    </CriteriaValue>
                  </CriteriaContent>
                </CriteriaContainer>
              </EligibilitySection>
              )}

              {status === 'MISSED' && (
                <div style={{ 
                  backgroundColor: '#10AD7A26', 
                  borderRadius: '10px', 
                  padding: '10px', 
                  marginTop: '15px',
                  border: '1px solid #10AD7A',
                  color: 'black'
                }}>
                  <div style={{ fontSize: '10px', marginBottom: '5px' }}>
                    <span style={{ fontWeight: '400' }}>Application end date:</span> <span style={{ fontWeight: '700' }}>{dateConversion({
                      date: data?.end_date,
                      convertTo: 'Date-Month-Year',
                    })}</span>
                  </div>
                  <div style={{ fontSize: '10px' }}>
                    <span style={{ fontWeight: '400' }}>Application end time:</span> <span style={{ fontWeight: '700' }}>{formatAMPM(new Date(data?.end_date))}</span>
                  </div>
                </div>
              )}
            </Col>
          </Row>

        </Col>
      </Row>
        </>
      )}
    </EligibilityContainer>
  )
}

export default EligibilityCriteria
